import React from 'react';

// MOCKUP 1: Underlined name + skill pills
export function HeroAccentPills() {
  return (
    <section className="border-b-2 border-black px-6 py-12 md:px-12 lg:px-24 bg-stone-100">
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-black mb-3 leading-tight">
          <span className="border-b-4 border-sky-400">Kevin Cogen</span>
        </h1>
        <p className="text-lg mb-4 font-bold bg-black text-white inline-block px-4 py-2 rounded-md">
          Product Manager & Developer
        </p>
        <p className="text-base leading-relaxed mb-3 max-w-2xl mx-auto">
       I combine product strategy with technical fluency to
build user-centered solutions that drive adoption, efficiency, and measurable business outcomes.
        </p>
        <br></br>
        <p className="text-base leading-relaxed max-w-2xl mx-auto">
          <b>My overarching builder's philosphy:</b> Everything is a system and all systems connect. 
          <br></br>
          User Experience is driven through Human-Centric Design and Elegant Engineering. 
        </p>
        <div className="flex flex-wrap justify-center gap-2 mt-6">
          <span className="px-3 py-1 bg-sky-200 border-2 border-black text-xs font-bold rounded-md">Full-Stack Technical PM</span>
          <span className="px-3 py-1 bg-sky-200 border-2 border-black text-xs font-bold rounded-md">API Strategy</span>
          <span className="px-3 py-1 bg-sky-200 border-2 border-black text-xs font-bold rounded-md">Data-Driven</span>
          <span className="px-3 py-1 bg-sky-200 border-2 border-black text-xs font-bold rounded-md">React/Node/SQL</span>
          <span className="px-3 py-1 bg-sky-200 border-2 border-black text-xs font-bold rounded-md">User-Centred Design</span>
        </div>
      </div>
    </section>
  );
}

// MOCKUP 2: Card container with shadow
// export function HeroCard() {
//   return (
//     <section className="px-6 py-12 md:px-12 lg:px-24 bg-stone-100">
//       <div className="max-w-2xl mx-auto">
//         <div className="border-2 border-black p-8 bg-white shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] rounded-lg text-center">
//           <h1 className="text-4xl md:text-5xl font-black mb-3 leading-tight">
//             Your Name
//           </h1>
//           <p className="text-lg mb-4 font-bold bg-black text-white inline-block px-4 py-2 rounded-md">
//             Product Manager & Developer
//           </p>
//           <p className="text-base leading-relaxed mb-3 max-w-2xl mx-auto">
//             Brief bio about yourself. Talk about your journey from development to product management, 
//             or how you blend both worlds. Keep it concise and engaging.
//           </p>
//           <p className="text-base leading-relaxed max-w-2xl mx-auto">
//             Additional context about what drives you, your approach to building products, 
//             or what you're currently focused on.
//           </p>
//           <div className="mt-6 text-sm text-neutral-600">
//             Full-Stack Technical PM • API Strategy • Data-Driven • React/Node/SQL • User-Centred Design
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// MOCKUP 3: Left-aligned with highlight block on name
export function HeroLeftAlign() {
  return (
    <section className="border-b-2 border-black px-6 py-12 md:px-12 lg:px-24 bg-stone-100">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-black mb-3 leading-tight">
          <span className="bg-sky-200 px-2">Kevin Cogen</span>
        </h1>
        <p className="text-lg mb-4 font-bold bg-black text-white inline-block px-4 py-2 rounded-md">
          Product Manager & Developer
        </p>
        <p className="text-base leading-relaxed mb-3 max-w-2xl">
          Brief bio about yourself. Talk about your journey from development to product management, 
          or how you blend both worlds. Keep it concise and engaging.
        </p>
        <p className="text-base leading-relaxed max-w-2xl">
          Additional context about what drives you, your approach to building products, 
          or what you're currently focused on.
        </p>
        <div className="mt-6 text-sm text-neutral-600">
          Full-Stack Technical PM • API Strategy • Data-Driven • React/Node/SQL • User-Centred Design
        </div>
      </div>
    </section>
  );
}

// MOCKUP 4: Combining card + pills + left-align
// export function HeroCombined() {
//   return (
//     <section className="px-6 py-12 md:px-12 lg:px-24 bg-slate-100">
//       <div className="max-w-2xl mx-auto">
//         <div className="border-2 border-black p-8 bg-white shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] rounded-lg">
//           <h1 className="text-4xl md:text-5xl font-black mb-3 leading-tight">
//             <span className="border-b-4 border-emerald-400">Your Name</span>
//           </h1>
//           <p className="text-lg mb-4 font-bold bg-black text-white inline-block px-4 py-2 rounded-md">
//             Product Manager & Developer
//           </p>
//           <p className="text-base leading-relaxed mb-3">
//             Brief bio about yourself. Talk about your journey from development to product management, 
//             or how you blend both worlds. Keep it concise and engaging.
//           </p>
//           <p className="text-base leading-relaxed">
//             Additional context about what drives you, your approach to building products, 
//             or what you're currently focused on.
//           </p>
//           <div className="flex flex-wrap gap-2 mt-6">
//             <span className="px-3 py-1 bg-emerald-100 border border-black text-xs font-medium rounded">Full-Stack Technical PM</span>
//             <span className="px-3 py-1 bg-emerald-100 border border-black text-xs font-medium rounded">API Strategy</span>
//             <span className="px-3 py-1 bg-emerald-100 border border-black text-xs font-medium rounded">Data-Driven</span>
//             <span className="px-3 py-1 bg-emerald-100 border border-black text-xs font-medium rounded">React/Node/SQL</span>
//             <span className="px-3 py-1 bg-emerald-100 border border-black text-xs font-medium rounded">User-Centred Design</span>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

export default HeroAccentPills;